import cx from 'classnames'
import styles from './IOJack.module.css'

export type IOJackDirection = 'input' | 'output'

export interface IOJackProps {
  /** Label shown under the socket */
  label: string
  /** Whether this is an input or output socket */
  direction: IOJackDirection
  /** Lights the signal lamp: cyan for inputs, hot pink for outputs */
  live?: boolean
  /** Additional CSS class */
  className?: string
}

/**
 * A quarter-inch jack socket with a signal lamp.
 * Signal lamps follow the logo's colour roles:
 * cyan for inputs, hot pink for outputs.
 */
export function IOJack({
  label,
  direction,
  live = false,
  className,
}: IOJackProps) {
  return (
    <div
      className={cx(styles.IOJack, className, {
        [styles.isInput]: direction === 'input',
        [styles.isOutput]: direction === 'output',
        [styles.isLive]: live,
      })}
    >
      <div className={styles.IOJack__socket}>
        <div className={styles.IOJack__bore} />
      </div>
      <span className={styles.IOJack__label}>{label}</span>
      <span
        className={styles.IOJack__signal}
        aria-hidden="true"
      />
    </div>
  )
}
